import { ReactElement, useEffect, useState } from 'react'
import {
  FlexWrapper,
  PageWrapper,
  DropdownWrapper,
  EditableDropdown,
  SectionTitle
} from '../../../components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import { getAllCoursesDropdown } from '../../../helpers'
import strings from '../../../locale/en'
import NewMaterial from './NewMaterial'
import { getCourses } from '../../../redux/course/action'
import { CourseDetails } from '../../../redux/course/types'
import { resetMaterialState } from '../../../redux/addMaterial/actions'

const AddMaterial = (): ReactElement => {
  const { courses } = useSelector(
    (state: RootState) => ({
      courses: state.course.coursesToAddMaterial
    }),
    shallowEqual
  )
  const materials = [1] // need to get it from redux
  const dispatch = useDispatch()
  const [subjects, setSubjects] = useState<CourseDetails | any>([])
  const [chapters, setChapters] = useState<CourseDetails | any>([])
  const [topics, setTopics] = useState<CourseDetails | any>([])
  const [selectedTopic, setSelectedTopic] = useState('')

  const courseList = courses ? getAllCoursesDropdown(courses) : []
  const subjectList = subjects ? getAllCoursesDropdown(subjects) : []
  const chaptersList = chapters ? getAllCoursesDropdown(chapters) : []
  const topicsList = topics ? getAllCoursesDropdown(topics) : []

  const {
    menu: {
      admin: { selectCourse, selectSubject, selectChapter, selectTopic },
      material: { add }
    }
  } = strings

  useEffect(() => {
    dispatch(getCourses())

    return () => {
      dispatch(resetMaterialState())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <SectionTitle title={add} hasBorder />
      <FlexWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={courseList}
            title={selectCourse}
            placeholder={selectCourse}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              const subjectsList = courses.filter(
                (course) => course?.value === item.id
              )
              setSubjects(subjectsList[0]?.children)
              setChapters([])
              setTopics([])
              setSelectedTopic('')
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={subjectList}
            title={`${selectSubject}`}
            placeholder={selectSubject}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              const chaptersList = subjects.filter(
                (subject: CourseDetails) => subject?.value === item.id
              )
              setChapters(chaptersList[0]?.children)
              setTopics([])
              setSelectedTopic('')
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={chaptersList}
            title={`${selectChapter}`}
            placeholder={selectChapter}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              const topicsList = chapters.filter(
                (chapter: CourseDetails) => chapter?.value === item.id
              )
              setTopics(topicsList[0]?.children)
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={topicsList}
            title={`${selectTopic}`}
            placeholder={selectTopic}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              setSelectedTopic(item?.id)
            }}
          />
        </DropdownWrapper>
      </FlexWrapper>
      {materials.map((material) => {
        return (
          <NewMaterial key={`material-${material}`} topicId={selectedTopic} />
        )
      })}
    </PageWrapper>
  )
}

export default AddMaterial
